module.exports = __webpack_public_path__ + "static/img/whiteLogo.2521b64.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/whiteLogo.png
// module id = g3/0
// module chunks = 2